var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-/-Language-/-Not-selected",
    transform: "translate(-16.000000, -12.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flag-/-England",
    transform: "translate(16.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.551187, 0.551187)",
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7563125,5.7076875 C1.4995,7.342875 0.5518125,9.2275625 -8.8817842e-16,11.275 L8.323625,11.275 L2.7563125,5.7076875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.897625,11.275 C30.3458125,9.227625 29.3980625,7.3429375 28.1413125,5.70775 L22.574125,11.275 L30.897625,11.275 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.99200722e-16,19.6228125 C0.551875,21.6701875 1.4995625,23.554875 2.7563125,25.19 L8.3234375,19.6228125 L-9.99200722e-16,19.6228125 L-9.99200722e-16,19.6228125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1899375,2.756375 C23.55475,1.4995625 21.670125,0.551875 19.6226875,-8.8817842e-16 L19.6226875,8.3235625 L25.1899375,2.756375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7076875,28.14125 C7.342875,29.3980625 9.2275625,30.34575 11.2749375,30.897625 L11.2749375,22.574125 L5.7076875,28.14125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.274875,-9.99200722e-16 C9.2275,0.551875 7.3428125,1.4995625 5.7076875,2.7563125 L11.274875,8.3235 L11.274875,-9.99200722e-16 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.62275,30.897625 C21.670125,30.34575 23.5548125,29.3980625 25.1899375,28.1413125 L19.62275,22.574125 L19.62275,30.897625 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.574125,19.6228125 L28.1413125,25.1900625 C29.3980625,23.5549375 30.3458125,21.6701875 30.897625,19.6228125 L22.574125,19.6228125 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8645625,13.9130625 L18.0870625,13.9130625 L18.087,13.9130625 L18.087,0.1354375 C17.4038125,0.0465 16.7073125,0 16,0 C15.2925625,0 14.5961875,0.0465 13.9130625,0.1354375 L13.9130625,13.9129375 L13.9130625,13.913 L0.1354375,13.913 C0.0465,14.5961875 0,15.2926875 0,16 C0,16.7074375 0.0465,17.4038125 0.1354375,18.0869375 L13.9129375,18.0869375 L13.913,18.0869375 L13.913,31.8645625 C14.5961875,31.9535 15.2925625,32 16,32 C16.7073125,32 17.4038125,31.9535625 18.0869375,31.8645625 L18.0869375,18.0870625 L18.0869375,18.087 L31.8645625,18.087 C31.9535,17.4038125 32,16.7074375 32,16 C32,15.2926875 31.9535,14.5961875 31.8645625,13.9130625 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1739375,20.1739375 L20.1739375,20.1739375 L27.3136875,27.31375 C27.6420625,26.9855 27.9553125,26.6423125 28.2541875,26.2865625 L22.1415625,20.1739375 L20.1739375,20.1739375 L20.1739375,20.1739375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8260625,20.174 L11.8259375,20.174 L4.68625,27.3136875 C5.0145,27.6420625 5.3576875,27.9553125 5.7134375,28.2541875 L11.8260625,22.1414375 L11.8260625,20.174 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8260625,11.8261875 L11.8260625,11.8260625 L4.6863125,4.68625 C4.3579375,5.0145 4.0446875,5.3576875 3.7458125,5.7134375 L9.8585,11.8261875 L11.8260625,11.8261875 L11.8260625,11.8261875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1739375,11.8261875 L20.1739375,11.8261875 L27.31375,4.6863125 C26.9855,4.3579375 26.6423125,4.0446875 26.2865625,3.745875 L20.1739375,9.8585625 L20.1739375,11.8261875 L20.1739375,11.8261875 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnFlag);
export default __webpack_public_path__ + "static/media/en-flag.44861301.svg";
export { ForwardRef as ReactComponent };